import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';

import Loading from './Loading';

const PrivateRoute = ({ children }) => {
    const { openTimeModal } = useTimeModal();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [isAuthorized, setIsAuthorized] = useState(null);
    const token = localStorage.getItem('token');

    useEffect(() => {
        if (!token) {
            setIsAuthorized(false);
            return;
        }

        axios.get('/api/get-my-user-role', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(response => {
            try {
                const decodedToken = jwtDecode(token);

                if (decodedToken.exp * 1000 < Date.now()) {
                    openTimeModal('Ваш токен истек. Перезайдите в систему', 'error');
                    localStorage.removeItem('token');
                    setIsAuthorized(false);
                } else if (decodedToken.role !== response.data?.role) {
                    openTimeModal('Вам изменили уровень доступа к системе. Для корректной работы перезайдите в учётную запись', 'error');
                    localStorage.removeItem('token');
                    navigate('/auth/login?redirect=/home');
                } else {
                    // Авторизован
                    setIsAuthorized(true);
                }
            } catch (error) {
                console.error('Ошибка декодирования токена:', error);
                openTimeModal('Неизвестная ошибка системы', 'error');
                localStorage.removeItem('token');
                setIsAuthorized(false);
            }
        }).catch(() => {
            localStorage.removeItem('token');
            setIsAuthorized(false);
        });
    }, [location]);

    // Формируем правильную ссылку редиректа
    let redirectPath = location.pathname + location.search;
    const caseId = searchParams.get('case');
    if (caseId) {
        redirectPath = `/case/${caseId}`;
    }

    if (isAuthorized === null) {
        return <Loading />;
    }

    return isAuthorized ? children : <Navigate to={`/auth/login?redirect=${redirectPath}`} />;
};

export default PrivateRoute;